<template>
  <section class="form-underwriting width-700">
    <el-form
      ref="form"
      :rules="rules"
      class="form-container"
      :model="formData">
      <!-- <div class="form-item">
        <span>Plan Level</span>
        <el-form-item
          prop="plan_tier"
        >
          <v-radio-group
            v-model="formData.plan_tier"
            :border="true"
            :list="planLevelOptions"
          />
        </el-form-item>
      </div> -->
    </el-form>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinRules from '@/mixins/rules'
export default {
  name: 'FormUnderwriting',
  mixins: [MixinOptions, MixinRules],
  props: {
    form: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {
        // class_id: 22,
        plan_tier: 0
      },
    }
  },
  computed: {
    localAllOptions() {
      return this.allOptions22
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        Object.keys(this.formData).some(key => {
          if(key in val) {
            this.formData[key] = val[key]
          }
        })
      }
    }
  },
  methods: {
    submitForm() {
      // 表單校驗
      this.$refs.form.validate(valid => {
        if(valid) {
          this.$emit('getFormData', {
            ...this.formData,
            class_id: 22
          })
        }
      })
      
    }
  }
}
</script>
<style lang="scss" scoped>
.form-underwriting {
  position: relative;
  // width: 700px;
}
</style>